<ng-container *ngIf="hasValidDisplay(); else emptyDisplay">
  <ng-container *ngIf="isNavigable; else plainDisplay">
    <!-- Navigable display with proper interaction handling -->
    <div
      [class]="getContainerClasses()"
      [matTooltip]="tooltipText"
      matTooltipShowDelay="300"
      matTooltipPosition="above">

      <!-- Left positioned icon -->
      <mat-icon
        *ngIf="showIcon && iconPosition === 'left'"
        [svgIcon]="icon"
        [class]="getIconClasses()"
        [ngClass]="{
          'cursor-pointer': isIconClickable(),
          'hover:text-blue-600': isIconClickable()
        }"
        [style.color]="'rgb(0, 0, 0)'"
        (click)="isIconClickable() ? handleIconClick() : null">
      </mat-icon>

      <!-- Text content -->
      <span
        *ngIf="showText"
        [class]="getTextClasses()"
        [ngClass]="{
          'cursor-pointer': isTextClickable(),
          'underline': shouldUnderlineText(),
          'hover:text-blue-600': isTextClickable()
        }"
        (click)="isTextClickable() ? handleTextClick() : null">
        {{ text }}
      </span>

      <!-- Right positioned icon -->
      <mat-icon
        *ngIf="showIcon && iconPosition === 'right'"
        [svgIcon]="icon"
        [class]="getIconClasses()"
        [ngClass]="{
          'cursor-pointer': isIconClickable(),
          'hover:text-blue-600': isIconClickable()
        }"
        [style.color]="'rgb(0, 0, 0)'"
        (click)="isIconClickable() ? handleIconClick() : null">
      </mat-icon>
    </div>
  </ng-container>

  <!-- Plain (non-navigable) display -->
  <ng-template #plainDisplay>
    <div [class]="getContainerClasses()">
      <!-- Left positioned icon (non-clickable) -->
      <mat-icon
        *ngIf="showIcon && iconPosition === 'left'"
        [svgIcon]="icon"
        [class]="getIconClasses()"
        [style.color]="'rgb(0, 0, 0)'">
      </mat-icon>

      <!-- Text content (non-clickable) -->
      <span
        *ngIf="showText"
        [class]="getTextClasses()">
        {{ text }}
      </span>

      <!-- Right positioned icon (non-clickable) -->
      <mat-icon
        *ngIf="showIcon && iconPosition === 'right'"
        [svgIcon]="icon"
        [class]="getIconClasses()"
        [style.color]="'rgb(0, 0, 0)'">
      </mat-icon>
    </div>
  </ng-template>
</ng-container>

<!-- Empty display fallback -->
<ng-template #emptyDisplay>
  <span class="text-gray-400 text-sm">-</span>
</ng-template>